import React from 'react'

function Dashboard() {
  return (
    <div className='text-center'>
      <img className='img-fluid my-5' style={{ borderRadius: '10px' }} src="https://media.giphy.com/media/l46Cy1rHbQ92uuLXa/giphy.gif" alt="dashboard_gif" />
    </div>
  )
}

export default Dashboard